module.exports = __webpack_public_path__ + "static/img/aurick.58f5aa0c.png";